import { render, staticRenderFns } from "./indexFooter.vue?vue&type=template&id=39196e59"
import script from "./indexFooter.vue?vue&type=script&lang=js"
export * from "./indexFooter.vue?vue&type=script&lang=js"
import style0 from "./indexFooter.vue?vue&type=style&index=0&id=39196e59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports